import React from 'react';
import type { LucideIcon } from 'lucide-react';

export function SectionHeading({
  icon: Icon,
  label,
}: {
  icon: LucideIcon;
  label: string;
}) {
  return (
    <h2 className="flex items-center gap-2.5 text-lg leading-tight font-semibold tracking-tight text-gray-900 sm:text-xl dark:text-gray-100">
      <Icon
        className="h-5 w-5 text-gray-900 dark:text-gray-100"
        strokeWidth={2}
      />
      {label}
    </h2>
  );
}

export function StatBlock({
  icon: Icon,
  label,
  value,
  className = '',
}: {
  icon: LucideIcon;
  label: string;
  value: string;
  className?: string;
}) {
  return (
    <div
      className={`flex min-w-0 flex-1 basis-0 flex-col first:pl-0 last:pr-0 ${className}`}
    >
      <div className="flex items-center gap-1.5">
        <Icon
          className="h-4 w-4 flex-shrink-0 text-gray-500 dark:text-gray-400"
          strokeWidth={2}
        />
        <span className="text-base font-medium text-gray-600 dark:text-gray-400">
          {label}
        </span>
      </div>
      <p className="mt-0.5 text-xl leading-tight font-semibold tracking-tight text-gray-900 sm:text-2xl dark:text-gray-100">
        {value}
      </p>
    </div>
  );
}
